// The debrief room's route (lane B7 S14, plan §3.4): #requisitions/R-…/debriefs/<cycle>/room[/<application>], the last
// part the candidate tab. Registered through the shell's view registry (lane contract C-29); ../register.ts imports
// this module with every other family's routes.ts.

import { createElement } from "react";
import { registerView, type ViewProps } from "@/shell/viewRegistry";
import { RoomPage } from "./RoomPage";

export const ROOM_ROUTE = /^requisitions\/R-\d+\/debriefs\/[^/]+\/room(?:\/[^/]+)?$/;

function RoomRoute({ route }: ViewProps) {
  const [rid = "", , cid = "", , tab] = route.parts;
  return createElement(RoomPage, { rid, cid, tab });
}

registerView(ROOM_ROUTE, RoomRoute, { lane: "B7", gates: ["debrief.open"] });
